import { ColWrap, MainCol } from "common/layouts/SideNavLayout/TwoCol";
import { Loadable } from "common/Loadable";
import { GENERAL_MODAL } from "common/modals/GeneralModal";
import { CTA } from "common/styleguide/CTA";
import { goalParticipantActions, goalParticipantSelectors } from "data/resources/goalParticipants";
import { commonActions, useFormatMessage } from "lib/localization";
import { showModal } from "lib/modalUtils";
import { downloadFile } from "lib/utils";
import React from "react";
import { connect } from "react-redux";
import { getChallengeId } from "../../challengeUtils";
import { challengeMessages } from "../../intlMessages";
import { Leaderboard } from "../../Leaderboard";

export const _AdminLeaderboard = (props) => {
  const fm = useFormatMessage();
  const { goal } = props;
  return (
    <ColWrap>
      <MainCol>
        <Leaderboard
          {...props}
          noLink
          fm={fm}
          rightTitle={
            <CTA
              onClick={() =>
                showModal(GENERAL_MODAL, {
                  component: fm(challengeMessages.csvDisclaimer),
                  confirmText: fm(challengeMessages.understand),
                  onConfirm: () => downloadFile(`/goal_participants.csv?goal_id=${goal.id}`),
                  showCancel: true,
                })
              }
              margins={false}
              grey
            >
              {fm(commonActions.exportCSV)}
            </CTA>
          }
        />
      </MainCol>
    </ColWrap>
  );
};

const LoadableAdminLeaderboard = (props) => {
  const resourceLoaded = () => Promise.all([props.loadParticipants()]);

  return <Loadable component={_AdminLeaderboard} resourceLoaded={resourceLoaded} {...props} />;
};

const mapStateToProps = (state, ownProps) => {
  const challengeId = getChallengeId(ownProps);
  return {
    participant: (pid) => goalParticipantSelectors.find(state, pid),
    participants: goalParticipantSelectors.byGoalId(state, challengeId),
    ranks: goalParticipantSelectors.ranksForGoal(state, challengeId),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const goalId = getChallengeId(ownProps);
  return {
    loadParticipants: (paginationParams) =>
      dispatch(goalParticipantActions.list({ goalId, ...paginationParams }, { goalId })),
  };
};

export const AdminLeaderboard = connect(mapStateToProps, mapDispatchToProps)(LoadableAdminLeaderboard);
